// Write (WritePage): the selected scene, a folder's scenes or the whole book in one scrivenings editor.
export { WritePage as component } from '../../views/WritePage.tsx';
export const room = 'write';
export const page = 'write';
export const title = 'Write';
export const help = 'scrivenings';
export const takesNode = true;
